import React from 'react'
import Header from '../compontents/Header'
import AboutUs from '../compontents/AboutUs'
import Footer from '../compontents/Footer'

const AboutUsPage = () => {
  return (
    <React.Fragment>
      <Header />
      <AboutUs />
      <Footer />
    </React.Fragment>
  )
}

export default AboutUsPage